<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Home',

    metaInfo () {
      return {
        title: this.$t('hero.title'),
        titleTemplate: (titleChunk) => {
          return titleChunk ? `${titleChunk} - ${this.$t('meta.titleTemplate')}` : this.$t('meta.titleTemplate')
        },
      }
    },

    extends: View,

    mixins: [
      LoadSections([
        'anonymous/sections/hero',
        // 'anonymous/styles/wave/sections/wave-header',
        // 'anonymous/styles/wave/sections/wave-specialties',
        // 'anonymous/styles/wave/sections/wave-experience',
        // 'anonymous/styles/wave/sections/wave-pro-details',
        // 'anonymous/styles/wave/sections/wave-contact',
        'anonymous/sections/about-our-product',
        'sections/contact-us',
        'sections/info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'home',
      },
    },
  }
</script>
